import React, { useEffect, useState } from "react";
import BrandHeader from "@/components/BrandHeader";
import { publicApi } from "@/lib/api";
import { ensureGtm, ensureMetaPixel } from "@/lib/tracking";

export default function PublicLayout({ children }) {
  const [cfg, setCfg] = useState({ logo_url: "", privacy_url: "https://swisswatch.com.my/policies/privacy-policy" });
  useEffect(() => {
    publicApi.config().then((r) => {
      setCfg(r.data);
      if (r.data.gtm_container_id) ensureGtm(r.data.gtm_container_id);
      if (r.data.meta_pixel_id) ensureMetaPixel(r.data.meta_pixel_id);
    }).catch(() => { /* keep defaults */ });
  }, []);

  return (
    <div style={{ minHeight: "100vh", display: "flex", flexDirection: "column", background: "#FFFFFF" }}>
      <BrandHeader label="Contact Hub" logoUrl={cfg.logo_url} testIdPrefix="public-header" />
      {/* Always-visible warm hours notice — applies to every public page. */}
      <div style={{ background: "#fafafa", borderBottom: "1px solid var(--scw-line)" }}>
        <div style={{ maxWidth: 1100, margin: "0 auto", padding: "12px 28px", fontSize: 13, color: "#5C5C5C", textAlign: "center" }} data-testid="hours-note">
          Send a message anytime. Our atelier replies Monday through Saturday, 09:00 to 21:00 (MYT).
        </div>
      </div>
      <main style={{ flex: 1, width: "100%" }}>{children}</main>
      <footer className="scw-footer" data-testid="public-footer">
        <div style={{ maxWidth: 1100, margin: "0 auto", padding: "0 28px" }}>
          <a href={cfg.privacy_url} target="_blank" rel="noreferrer" data-testid="privacy-policy-link">Privacy Policy</a>
        </div>
      </footer>
    </div>
  );
}
